import React, { useState, useEffect } from 'react';

const NotificationBadge = ({ count = 0, size = 'default' }) => {
    const [shouldAnimate, setShouldAnimate] = useState(true);

    // Animation pulse uniquement au premier affichage
    useEffect(() => {
        if (count > 0) {
            setShouldAnimate(true);
            const timer = setTimeout(() => {
                setShouldAnimate(false);
            }, 4000); // 4 secondes d'animation (2 cycles de 2s)

            return () => clearTimeout(timer);
        }
    }, [count]);

    // Ne rien afficher si count === 0
    if (count === 0) {
        return null;
    }

    // Tailles en fonction du variant
    const sizeClasses = {
        small: 'min-w-[18px] h-[18px] px-1.5 text-[11px]',
        default: 'min-w-[24px] h-[24px] px-2 text-xs',
        large: 'min-w-[32px] h-[32px] px-2.5 text-sm'
    };

    return (
        <span
            className={`
                ${sizeClasses[size]}
                inline-flex items-center justify-center
                bg-red-500 text-white font-bold rounded-full
                transition-all duration-300 ease-out
                ${shouldAnimate ? 'animate-bounce-in' : ''}
            `}
            style={shouldAnimate ? { opacity: 0 } : {}}
            title={`${count} message${count > 1 ? 's' : ''} non lu${count > 1 ? 's' : ''}`}
        >
            {count > 99 ? '99+' : count}
        </span>
    );
};

export default NotificationBadge;
